// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-style {
  text-decoration: none;
  color: inherit;
  outline: none;
}

.search-container {
  position: relative;
}

.search-image{
  filter: brightness(70%);
  width: 100%;
  height: auto;
}

.image-wrapper {
  width: 100%; 
  height: 400px;
  overflow: hidden;
  position: relative;
  display: inline-block;
}

.search-input {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  padding: 10px;
}

.sentence {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  color: white; 
}

.image-item {
  filter: brightness(80%);
  flex: 0 0 25%; /* Adjust this value based on the number of columns you want */
  padding: 15px;
}

.image-item img {
  width: 100%;
  height: 100%;
  border-radius: 15px;
}

.card-img-top {
  object-fit: cover;
  height: 220px;
  width: 100%;
}

.rating-stars i {
  color: gold;
}

.item {
  padding: 10px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  margin-right: 20px;
}

.reivew {
  display: flex;
  margin: 5px;
  flex-direction: row;
  justify-content: space-between;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

footer{
  margin-top: auto;
}

.result-list {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 8px #ddd;
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
}

.search-result {
  padding: 10px 20px;
}

.search-result:hover {
  background-color: #efefef;
}

.flex-container {
  display: flex;
}

.comment{
  width: 19rem;
  margin-right: 10px;
}

.happyboy{
  max-width: 100%;
  height: auto;
}

.writing{
  display: flex;
  justify-content: flex-center
}

.writingman{
  height: 200px;
}

.card-body{
  max-width: 85%;
}

.square{
  width: 100px; 
  height: 100px;
  margin-top: 10px;
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa,EAAE,8DAA8D;EAC7E,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".link-style {\n  text-decoration: none;\n  color: inherit;\n  outline: none;\n}\n\n.search-container {\n  position: relative;\n}\n\n.search-image{\n  filter: brightness(70%);\n  width: 100%;\n  height: auto;\n}\n\n.image-wrapper {\n  width: 100%; \n  height: 400px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n}\n\n.search-input {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n  padding: 10px;\n}\n\n.sentence {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1;\n  color: white; \n}\n\n.image-item {\n  filter: brightness(80%);\n  flex: 0 0 25%; /* Adjust this value based on the number of columns you want */\n  padding: 15px;\n}\n\n.image-item img {\n  width: 100%;\n  height: 100%;\n  border-radius: 15px;\n}\n\n.card-img-top {\n  object-fit: cover;\n  height: 220px;\n  width: 100%;\n}\n\n.rating-stars i {\n  color: gold;\n}\n\n.item {\n  padding: 10px;\n}\n\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.card-body {\n  margin-right: 20px;\n}\n\n.reivew {\n  display: flex;\n  margin: 5px;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.main {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nfooter{\n  margin-top: auto;\n}\n\n.result-list {\n  width: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 0px 8px #ddd;\n  border-radius: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.search-result {\n  padding: 10px 20px;\n}\n\n.search-result:hover {\n  background-color: #efefef;\n}\n\n.flex-container {\n  display: flex;\n}\n\n.comment{\n  width: 19rem;\n  margin-right: 10px;\n}\n\n.happyboy{\n  max-width: 100%;\n  height: auto;\n}\n\n.writing{\n  display: flex;\n  justify-content: flex-center\n}\n\n.writingman{\n  height: 200px;\n}\n\n.card-body{\n  max-width: 85%;\n}\n\n.square{\n  width: 100px; \n  height: 100px;\n  margin-top: 10px;\n  margin-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
